<template>
  <div class="index-data">
    <div class="index-box" v-for="(item) in indexData.index" :key="item.id">
      <div class="one-index" :id="`start-${item.id}`">
        <div class="value">
          {{item.data.yData[item.data.yData.length-1]}}
          <span class="rate" :class="item.data.rate[item.data.rate.length-1] > 0 ? 'up' :item.data.rate[item.data.rate.length-1] < 0 ? 'down' : ''">{{item.data.rate[item.data.rate.length-1]}}</span>
        </div>
        <div class="title">
          {{$filters.wholeReplace(item.name,'武安小米','')}}
        </div>
      </div>
      <div class="index-cate">
        <div class="cate-item" v-for="(item1) in item.children.slice(0,3)" :id="`end-${item1.id}-${item1.code}`" :key="item1.id">
          <div class="item-box">
            <div class="value">{{item1.data && item1.data.yData[item1.data.yData.length-1]}}</div>
            <div class="label">{{item1.name.slice(0,4)}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onUpdated } from 'vue'
import { useStore } from 'vuex'
import LeaderLine from 'leader-line'

// vuex
const store = useStore()

/** 从vuex中获取指数数据 */
const indexData = computed(() => {
  return {
    index: [...store.getters.index]
  }
})

/** 获取节点 */
const getNodes = () => {
  indexData.value.index.forEach(v => {
    const startNode = document.getElementById(`start-${v.id}`)
    if (v.children.length) {
      v.children.forEach((item, i) => {
        if (i > 2) return
        const endNode = document.getElementById(`end-${item.id}-${item.code}`)
        drawLine(startNode, endNode)
      })
    }
  })
}

/** 连线 */
const drawLine = (start, end) => {
  const lineContainer = new LeaderLine(start, end, {
    color: '#fff',
    size: 1,
    startPlug: 'square',
    endPlug: 'square'
  })
  const showEffectName = 'draw'
  lineContainer.setOptions({
    dropShadow: { dx: 0, dy: 3 }
  })
  lineContainer.show(showEffectName)
}

onUpdated(() => {
  getNodes()
})
</script>

<style lang="scss" scoped>
.index-data{
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  width: 100%;
  height: 242px;
  padding-top: 10px;
  .index-box{
    flex: 1;
    .one-index{
      height: 90px;
      background: url('~@/assets/images/index-item-bg.png') no-repeat;
      background-size: 85% 80%;
      background-position: center bottom;
      text-align: center;
      .value{
        font-size: 26px;
        font-weight: 600;
        color: #C4E8FE;
        .rate{
          position: relative;
          font-size: 12px;
          color: #30DF82;
          padding-left: 10px;
          &::before{
            content: '';
            position: absolute;
            left: -5px;
            top: 50%;
            transform: translateY(-50%);
            width: 0;
            height: 0;
            border: 5px solid transparent;
          }
        }
        .up{
          color: red;
          &::before{
            border-bottom-color: red;
          }
        }
        .down{
          color: #30DF82;
          &::before{
            border-top-color: #30DF82;
          }
        }
      }
      .title{
        font-size: 16px;
      }
    }
    .index-cate{
      display: flex;
      justify-content: space-around;
      margin-top: 80px;
      .cate-item{
        width: 30%;
        padding-top: 10px;
        .item-box{
          background: linear-gradient(180deg, #59A1FA 0%, #0A397B 100%);
          opacity: 0.8;
          font-size: 12px;
          border: 1px dashed #EDFF30;
          text-align: center;
          padding: 5px 0;
        }
        .value{
          color: #EDFF30;
        }
        .label{
          margin-top: 5px;
          zoom: 0.8;
        }
      }
    }
  }
}
</style>
